import React from "react";
import { Link } from "react-router-dom";
import { userMenuLinks } from "../../../data";
import { useTranslation } from "react-i18next";
import SignOut from "../SignOut/SignOut";
const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <>
      <nav
        className="offcanvasNavigation user__sidebar_nav"
        id="offcanvas-navigation"
      >
        <ul
        className="offcanvasNavigation"
        
        >
          {userMenuLinks.map((val, index) => {
            return (
              <li
                className="menuItemHasChildren"
                key={index}
              >
                <Link to={process.env.PUBLIC_URL + val.url}>
                  {t(val.title)}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <div
        className="col user__sidebar_btn"
        
       
      >
        <SignOut isColor={true} />
      </div>
    </>
  );
};

export default Sidebar;
